export const LOGIN_REQUEST="LOGIN_REQUEST";
export const LOGIN_FAILURE="LOGIN_FAILURE";

export const POST_LOGIN_SUCCESS="POST_LOGIN_SUCCESS";

